module.exports = __webpack_public_path__ + "static/media/Features 2.72af0f46.svg";